<template>
    <div style=" height: 100%;">
        <div id="csContainer">
             <div class="fogdiv">
             <el-checkbox class="shadow" size="small " v-model="checked" label="雪" border></el-checkbox>
          </div>
        </div>
    </div>
</template>

<script>
    import util from "../../components/util"

    export default {
        data() {
            return {
                viewer: null,
                checked:false
            }
        },
        watch:{
           checked:function(val) {
             if(val===true){
                 this.snow()
             }else if(val===false){
                 this.viewer.scene.postProcessStages.removeAll();
             }
           }
        },
        mounted() {
            this.init();
            // this.snow();
        },
        methods: {
            init() {
               this.viewer = util.getViewer("csContainer", {
                    contextOptions: {
                        webgl: {
                            alpha: true,
                            depth: false,
                            stencil: true,
                            antialias: true,
                            premultipliedAlpha: true,
                            preserveDrawingBuffer: true,
                            failIfMajorPerformanceCaveat: true
                        },
                        allowTextureFilterAnisotropic: true
                    },
                });
                // this.vw = vw;
                util.setViewRegion(this.viewer);
            },
            //定义下雪场景 着色器
            FS_Snow() {
                let glsl = `
                uniform sampler2D colorTexture;
                varying vec2 v_textureCoordinates;
                float snow(vec2 uv,float scale)
                {
                    float time = czm_frameNumber / 60.0;
                    float w=smoothstep(1.,0.,-uv.y*(scale/10.));if(w<.1)return 0.;
                    uv+=time/scale;uv.y+=time*2./scale;uv.x+=sin(uv.y+time*.5)/scale;
                    uv*=scale;vec2 s=floor(uv),f=fract(uv),p;float k=3.,d;
                    p=.5+.35*sin(11.*fract(sin((s+p+scale)*mat2(7,3,6,5))*5.))-f;d=length(p);k=min(d,k);
                    k=smoothstep(0.,k,sin(f.x+f.y)*0.01);
                    return k*w;
                }

                void main(void){
                    vec2 resolution = czm_viewport.zw;
                    vec2 uv=(gl_FragCoord.xy*2.-resolution.xy)/min(resolution.x,resolution.y);
                    vec3 finalColor=vec3(0);
                    float c = 0.0;
                    c+=snow(uv,30.)*.0;
                    c+=snow(uv,20.)*.0;
                    c+=snow(uv,15.)*.0;
                    c+=snow(uv,10.);
                    c+=snow(uv,8.);
                    c+=snow(uv,6.);
                    c+=snow(uv,5.);
                    finalColor=(vec3(c));
                    gl_FragColor = mix(texture2D(colorTexture, v_textureCoordinates), vec4(finalColor,1), 0.5);
                }`;
                return glsl;
            },
            snow() {
                // let viewer = this.vw;
                let collection = this.viewer.scene.postProcessStages;
                let fs_snow = this.FS_Snow();
                let snow = new Cesium.PostProcessStage({
                    name: 'czm_snow',
                    fragmentShader: fs_snow
                });
                collection.add(snow);

                // viewer.scene.skyAtmosphere.hueShift = -0.8;
                // viewer.scene.skyAtmosphere.saturationShift = -0.7;
                // viewer.scene.skyAtmosphere.brightnessShift = -0.33;
                // viewer.scene.fog.density = 0.001;
                // viewer.scene.fog.minimumBrightness = 0.8;
            },


        }
    }
</script>

<style scoped>
    #csContainer {
        width: 100%;
        height: 100%;
        margin: 0;
        padding: 0;
        overflow: hidden;
    }
    .fogdiv {
        position: absolute;
        margin-left: 25px;
        margin-top: 7px;
        z-index: 999;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .shadow{
        color:white !important;
    }
</style>
